import { PAGE } from '../../../renderers/shared/pageTypes';

/**
* Add template page support to pages.
*/
export default function pageMigrations(pages) {
  let newPages = {};
  Object.keys(pages).forEach(id => {
    const newPage = { ...pages[id] };

    // Migrate from version undefined to version 1.
    // Introduction of template page support.
    if (!newPage.version) {
      // Increment version
      newPage.version = 1;
      // Change the rootLayoutItemId string to an array of rootLayoutItemIds.
      if (newPage.rootLayoutItemId) {
        newPage.rootLayoutItemIds = [newPage.rootLayoutItemId];
        delete newPage.rootLayoutItemId;
      }
      // Add the type property onto pages if it doesnt exist.
      if (!newPage.type) {
        newPage.type = PAGE;
      }
    }

    // Update the page in the object.
    newPages[id] = newPage;
  });
  return newPages;
}
